import { TDoor } from 'shared/types/doors';
import { DoorContent } from '../DoorContent';

export const FourthDoorContent: React.FC<TDoor> = props => {
  return (
    <DoorContent btnText="Посмотреть открытки" {...props}>
      <div>Праздники — лучший повод для тёплого контакта с вашими гостями.</div>
      <div>
        <b>🎁 Наш подарок — набор стильных новогодних открыток</b>
        <div>
          Отправьте их гостям, чтобы поздравить с праздниками, подчеркнуть заботу и ненавязчиво напомнить о себе.
        </div>
      </div>
      <div>
        Используйте этот тёплый подход, чтобы укрепить связь с теми, кто уже останавливался у вас, и создать приятное
        впечатление для будущих гостей.
      </div>
      <div>
        А чтобы привлечь новых гостей — используйте специальные{' '}
        <a href="https://t.me/cian_posutochno/24120/127485" target="_blank" rel="noreferrer">
          Скидки на длительное проживание
        </a>
        . Установите выгодные условия, чтобы ваше предложение выделялось в поиске и на карте и привлекало тех, кто
        планирует путешествия в новом году.
      </div>
      <div>Пусть ваш 2026 год начнётся с полной загрузки и ярких отзывов!</div>
    </DoorContent>
  );
};
